const constants = {
    GOOGLE_MAP_API_KEY: 'AIzaSyD-7kzo47fZMNaWiYvsK8bACYuF1pR-RrM',
};

/**
 * @deprecated user role should be used to check for admin. See {UserPerms}
 */
export const adminEmails = [
    'sergey.s@myco.com',
    'ss@shipnext.com',
    's.semernev@shipnext.com',
    'n.liashenko@shipnext.com',
    'serhsamiy@gmail.com',
    'd.kundasov@shipnext.com',
    'chartering@l3r.net',
    'e.koraia@shipnext.com',
    'chepkalenkos@mail.ru',
    'oxidksushkin@gmail.com',
    'vzoteeva0308@gmail.com',
];

export default constants;



// WEBPACK FOOTER //
// ./app/constants/index.js